import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import placeholder from "~/assets/placeholder-image.svg";
import AdminImageUploader from "~/Admin/AdminImageUploader/AdminImageUploader";
import Translated from "~/Admin/AdminMultilang/Translated";

const AdminEventOverview = ({match, event, onChange, ...props}) => {

    const [form, setForm] = useState({
        welcome_message: event.welcome_message,
        overview: event.overview,
        address: event.address,
        address_link: event.address_link,
        translations: event.translations
    });

    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const handleSubmit = () => {
        adminHttp
            .put('/events/' + event.id + '/overview', form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');

                if (onChange) {
                    onChange();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    };

    useEffect(() => {
        setForm({
            welcome_message: event.welcome_message,
            overview: event.overview,
            address: event.address,
            address_link: event.address_link,
            translations: event.translations
        })
    }, [event])

    return (
        <div>

            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <h3>Event Overview</h3>

                    {message && (
                        <div className="alert alert-success" role="alert">
                            {message}
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving event!"}
                        </div>
                    )}

                    <div className="form-group required">
                        <label>Welcome Message</label>

                        <Translated translations={form.translations}
                                    onChanged={(values) => setForm({...form, translations: values})}>
                            <textarea
                                onChange={handleChange}
                                value={form.welcome_message}
                                name="welcome_message"
                                className="form-control"/>
                        </Translated>

                        <ValidationError errors={error?.errors} name="welcome_message"/>
                    </div>

                    <div className="form-group required">
                        <label className="d-block">Overview Paragraph</label>
                        <small className="d-block">This copy will be displayed within the Event overview section of
                            “Your Experience” page.</small>

                        <Translated translations={form.translations}
                                    onChanged={(values) => setForm({...form, translations: values})}>
                        <textarea
                            onChange={handleChange}
                            value={form.overview}
                            name="overview"
                            className="form-control"/>
                        </Translated>

                        <ValidationError errors={error?.errors} name="overview"/>
                    </div>

                    <div className="form-group">
                        <label className="d-block">Overview Image</label>

                        <img className="img-thumbnail mb-2 d-block"
                             src={event.overview_image.download_url || placeholder}/>

                        <AdminImageUploader
                            image={event.overview_image}
                            onChanged={onChange}
                            className="text-primary cursor-pointer d-block">Edit Overview Image</AdminImageUploader>

                    </div>
                </div>
            </div>
            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3>Event Address</h3>

                    <div className="form-group required">
                        <label className="d-block">Event Address</label>
                        <small className="d-block">Please make sure to include the full address, including postcode and
                            city</small>

                        <Translated translations={form.translations}
                                    onChanged={(values) => setForm({...form, translations: values})}>
                            <textarea
                                onChange={handleChange}
                                value={form.address}
                                name="address"
                                type="text"
                                className="form-control"/>
                        </Translated>


                        <ValidationError errors={error?.errors} name="address"/>
                    </div>

                    <div className="form-group required">
                        <label className="d-block">Address Link</label>
                        <small className="d-block">Please insert a google map link of the location’s address</small>

                        <Translated translations={form.translations}
                                    onChanged={(values) => setForm({...form, translations: values})}>
                            <textarea
                                onChange={handleChange}
                                value={form.address_link}
                                name="address_link"
                                type="text"
                                className="form-control"/>
                        </Translated>

                        <ValidationError errors={error?.errors} name="address_link"/>
                    </div>

                </div>
            </div>
            <button
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right mt-3">
                Save
            </button>
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventOverview);
